import { app } from "modular-openscriptjs";

const h = app("h");

export default function MapSuggestedAddressView(place, ...args) {
	return h.div(
		{
			class: "border-bottom p-3 d-flex align-items-center bg-white hover-bg-light transition-base",
			role: "button",
			style: "cursor: pointer;",
		},
		h.span(
			{ class: "me-3 text-secondary" },
			h.i({ class: "fas fa-map-marker-alt" })
		),
		h.span({ class: "flex-fill fw-medium text-dark" }, place),
		h.i({ class: "fas fa-chevron-right text-muted small" }),
		...args
	);
}
